import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class CreateOperativeUnitDto {
  @Expose()
  code: string;

  @Expose()
  name: string;

  @Expose()
  businessUnitId?: string | null;

  @Expose()
  responsibleId?: string | null;

  @Expose()
  codification: string;

  @Expose()
  color: string;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined ? undefined : toCents(value)))
  onCallHourlyRate?: number;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined ? undefined : toCents(value)))
  onCallActivationPrice?: number;
}
